// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__014li","logo":"Navbar_logo__yGaIR","title":"Navbar_title__WohJx","prod":"Navbar_prod__aqsHR","qa":"Navbar_qa__2g+UP","dev":"Navbar_dev__suxk-"};